/* eslint-disable no-bitwise */
/* eslint-disable no-restricted-syntax */
import { isArray } from 'lodash';
import { BinaryConditionItemType } from './types';

export const toBinaryString = (stream: number, radix: number, length?: number): string => {
  const binaryString = stream.toString(radix);
  if (length) {
    const lengthDiff = length - binaryString.length;

    return '0'.repeat(lengthDiff) + binaryString;
  }
  return binaryString;
};

export const hasPart = (sourceStr: string, search: string | string[], bitStartIndex: number | number[]): boolean => {
  const startIndexes = isArray(bitStartIndex) ? bitStartIndex : [bitStartIndex];

  return startIndexes.some((startIndex) => {
    const partLength = isArray(search) ? search[0].length : search.length;
    const part = sourceStr.substring(startIndex - 1, startIndex - 1 + partLength);
    return isArray(search) ? search.includes(part) : part === search;
  });
};

export const checkConditions = (
  sourceStr: string,
  conditions: BinaryConditionItemType[],
  differentSources?: Record<string, string>,
): boolean => {
  if (!conditions) {
    return true;
  }

  let result = true;
  for (const condition of conditions) {
    if (!result) {
      return result;
    }

    result = hasPart(
      (differentSources && condition.differentSourceReference
        ? differentSources[condition.differentSourceReference]
        : undefined) || sourceStr,
      condition.contains,
      condition.bitStartIndex,
    );
  }
  return result;
};
